export const numberWithCommas = (x) => {
    return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
export const userPlaceholderImage = 'https://www.seekpng.com/png/detail/966-9665317_placeholder-image-person-jpg.png'
export const userLanguage = window.localStorage.getItem('language') || 'en'
export const userCountry = window.localStorage.getItem('country') || 'us'
export const linkColor = '#CAE4F1'